import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, Text, TouchableWithoutFeedback } from 'react-native';
import { pt, sendClickDataWithJsonParam} from '../../../../components/utiles';
import {
    JDImage
} from '@jdreact/jdreact-core-lib';

const styles = StyleSheet.create({
    body: {
        marginTop: pt(20),
        marginLeft: 0,
    },
    header: {
        width: pt(750),
        paddingHorizontal: pt(24),
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: pt(30)
    },
    headerText: {
        fontSize: pt(28)
    },
    headerImg: {
        width: pt(28),
        height: pt(28)
    },
    content: {
        width: pt(750),
        backgroundColor: '#ffffff',
        paddingHorizontal: pt(24)
    },
    historyItemBox: {
        height:pt(88),
        backgroundColor: '#ffffff',
        justifyContent: 'center',
        borderBottomWidth: pt(1),
        borderBottomColor: '#f6f6f6'
    },
    historyItemText: {
        fontSize: pt(28),
        color: '#2E2D2D'
    },
    contentView: {
        width: pt(54),
        height: pt(54),
        backgroundColor: 'rgba(246,246,246,1)',
        borderRadius: pt(27),
        justifyContent: 'center',
        alignItems: 'center'
    },
    contentImg: {
        width: pt(28),
        height: pt(28)
    }
});

export default class SearchHistory extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            historyList: this.props.historyList
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.setState({
                historyList: this.props.historyList,
            });
        }
    }

    componentDidMount() {
       
    }

    clearHistory = () => {
        this.props.clearHistory();
    }

    render() {
        const {
            customizeHotAndHistoryStyle
        } = this.props;
        const {
            historyList,
        } = this.state;
        return (
            <TouchableWithoutFeedback onPress={null}>
                <View style={[styles.body, customizeHotAndHistoryStyle ? { ...customizeHotAndHistoryStyle } : '']}>
                    {historyList.length > 0 && <View style={styles.header}>
                        <Text style={styles.headerText}>搜索历史</Text>
                        <TouchableWithoutFeedback onPress={this.clearHistory}>
                            <JDImage
                                style={styles.headerImg}
                                source={{
                                    uri: 'https://img10.360buyimg.com/imagetools/jfs/t1/155540/8/29526/1642/63101da2Ef3dabe44/6d2548a7104319fe.png'
                                }}
                            />
                        </TouchableWithoutFeedback>
                    </View>}
                    <View style={[styles.content]}>
                        {
                            historyList.map((item, index) =>
                            <TouchableWithoutFeedback key={index+'_history'} onPress={() => {
                                sendClickDataWithJsonParam({
                                    event_id: 'OfficeBuilding_SearchList_SearchHistory',
                                    page_id: this.props.pageId,
                                    json_param: {
                                        searchword: item.searchName || ''
                                    },
                                })
                                setTimeout(() => {
                                    this.props.goHistorySearch(item.searchName)
                                }, 300)
                                }}>
                                <View style={styles.historyItemBox}>
                                    <Text style={styles.historyItemText}>{item.searchName}</Text>
                                </View>
                            </TouchableWithoutFeedback>
                        )} 
                    </View>
                </View>
            </TouchableWithoutFeedback>
        );
    }
};
SearchHistory.propTypes = {
    historyList: PropTypes.array,
    clearHistory: PropTypes.func,
    customizeHotAndHistoryStyle: PropTypes.object
};

SearchHistory.defaultProps = {
    historyList: [],
    customizeHotAndHistoryStyle: {},
    clearHistory: () => {}
};
